import { createResource } from 'react-resource-router';

import { assert, AssertionError } from '@atlassian/eoc-common';

import { getDetail } from '../../endpoints/detail';

const detailResource = createResource({
	type: 'getDetailResource',
	getKey: () => 'getDetailResource',
	getData: async (routerContext) => {
		const id = routerContext.match.params?.id;

		assert(
			!!id,
			new AssertionError('detailResource', 'id should be set to fetch incoming call detail'),
		);

		return getDetail(id);
	},
	isBrowserOnly: true,
});

export { detailResource };
